import { NgModule } from '@angular/core';
import { ClickedOutsideDirective } from './_directives/click-outside';

@NgModule({
  imports: [],
  declarations: [ClickedOutsideDirective],
  exports: [ClickedOutsideDirective]
})
export class DirectivesModule { }
